export const site = {
  nome: 'Informadialogica',
  autore: 'Roberto Levorato',
  // Testi condivisi dal sito e metadati globali. I contenuti della Hero si
  // modificano dal pannello, nella pagina Home.
  claim: 'Un luogo per dialogare, che è l’unico modo per vivere e per crescere.',
  descrizione:
    'Riflessioni su pace, ecologia, giustizia, filosofia, spiritualità e arte. Un percorso insieme interiore e pratico, individuale e comunitario, locale e universale.',
  email: process.env.NEXT_PUBLIC_SITE_EMAIL ?? 'roberto@informadialogica.it',
  url: (process.env.NEXT_PUBLIC_SERVER_URL ?? 'http://localhost:3000').replace(/\/$/, ''),
  blogTitolo: 'Il sentiero del millimetro',
  immagineSociale: '/immagini/apertura-social.webp',
  articoliPerPagina: 9,
} as const

export const assoluto = (percorso: string): string =>
  percorso.startsWith('http') ? percorso : `${site.url}${percorso.startsWith('/') ? '' : '/'}${percorso}`

export const navigazione = [
  { href: '/', etichetta: 'Home' },
  { href: '/blog', etichetta: 'Blog' },
  { href: '/temi', etichetta: 'Temi' },
  { href: '/chi-sono', etichetta: 'Chi sono' },
  { href: '/contatti', etichetta: 'Contatti' },
] as const
